import type { ChatListEntry } from "@altek/ui/components/chat/ChatList";

/** Taslağın kimliği — gerçek bir konuşma kimliği DEĞİL, listede ve seçimde onun yerini tutuyor. */
export const DRAFT_CONVERSATION_ID = "draft";

/** Ad henüz bilinmiyorsa (rehber cevabı gelmedi) taslağın başlığı ve satırı. */
export const DRAFT_FALLBACK_NAME = "Yeni sohbet";

/**
 * TASLAK SATIRI — listenin en üstünde ve sahte: sunucuda karşılığı yok.
 *
 * Listede görünmesi gerekiyor çünkü yanındaki yazma alanı onun konuşması; solda karşılığı olmayan
 * bir konuşma «bu nereden geldi» sorusunu doğurur. Adı KİŞİNİN adı (sayfa ve yuva rehberden aynı
 * sorguyla okuyor); eskiden her taslak satırı «Canlı yardım» diyordu, rehberden başlatılan bir
 * sohbette bile.
 */
export function draftListEntry(name: string | undefined): ChatListEntry {
  return {
    id: DRAFT_CONVERSATION_ID,
    kind: "direct",
    name: name ?? DRAFT_FALLBACK_NAME,
    unreadCount: 0,
    muted: false,
    pinned: false,
    archived: false,
  };
}

/**
 * TASLAKTAN GERÇEK KONUŞMAYA DEVİR — gönderilemeyen metinle birlikte.
 *
 * Arşivdeki bir birebir sohbete taslaktan yazılınca sunucu konuşmayı döndürüyor ama mesajı
 * reddediyor (409 `CONVERSATION_ARCHIVED`). Taslak orada takılı kalıyordu: arşivden çıkarmanın
 * yolu yoktu, kişi yalnız bir hata bildirimi görüyordu. Artık yüzey gerçek konuşmaya geçiyor
 * (engelin nedeni ve «Arşivden çıkar» orada) ve yazılan metin o konuşmanın yazma kutusuna
 * taşınıyor.
 */
export interface DraftHandoff {
  unsentText: string;
}

/**
 * Sohbet SAYFASINDA devir adresle birlikte gidiyor (`navigate(..., { state })`): `/chat?with=`
 * ile `/chat/:id` iki ayrı rota, sayfa yeniden bağlanıyor ve bileşenin taslak deposu onunla
 * sıfırlanıyor. Durumdan okunan değer yalnız doğru biçimdeyse kabul ediliyor.
 */
export interface UnsentDraftState {
  unsentDraft: { conversationId: string; text: string };
}

export function unsentDraftFrom(state: unknown): UnsentDraftState["unsentDraft"] | null {
  if (typeof state !== "object" || state === null) return null;
  const candidate = (state as Partial<UnsentDraftState>).unsentDraft;
  if (
    typeof candidate !== "object" ||
    candidate === null ||
    typeof candidate.conversationId !== "string" ||
    typeof candidate.text !== "string"
  ) {
    return null;
  }
  return candidate;
}
